var offsetX = 0;
var offsetY = 0;
var width = 40;
var height = 20;
var rotate = 0;
var marginX = 2.0;
var marginY = 2.0;
var barCodeWidth = width - marginX * 2;
var barCodeHeight = height - marginY * 2;
var fontSize = 3.2;

/**
 * 生成VTM打印数据
 * @param {Object} variables - 变量对象
 * @param {string} variables.machineType - 机器类型（用于条形码）
 * @param {string} variables.imei - IMEI号码（用于条形码）
 * @param {string} variables.sn - 序列号（用于条形码，对应 cardReader）
 * @param {string} variables.help - 帮助信息（文本）
 * @param {string} variables.company - 公司信息（文本）
 * @returns {Object} VTM打印数据对象
 */
export function createVtmPrintData(variables = {}) {
	// 默认值
	const { machineType = "", imei = "", sn = "", help = "", company = "VapeTM Vending\nwww.VapeTM.com" } = variables;

	return {
		elements: [
			{
				type: "graph",
				json: {
					x: 2.986119588216146,
					y: 2.6388899485270185,
					height: 94,
					width: 64.25,
					graphType: 4,
					rotate: 0,
					cornerRadius: 0,
					lineWidth: 0.4,
					lineType: 1,
					dashwidth: [0.75, 0.75],
				},
			},
			{
				type: "line",
				json: {
					x: 3.1944402058919295,
					y: 30.07777989705404,
					height: 0.4,
					width: 63.75,
					lineType: 1,
					rotate: 0,
					dashwidth: [0.75, 0.75],
				},
			},
			{
				type: "line",
				json: {
					x: 6.0069402058919295,
					y: 49.140279897054036,
					height: 0.4,
					width: 93.54166666666667,
					lineType: 1,
					rotate: 90,
					dashwidth: [0.75, 0.75],
				},
			},
			{
				type: "line",
				json: {
					x: -5.659726460774735,
					y: 49.5569465637207,
					height: 0.4,
					width: 93.54166666666669,
					lineType: 1,
					rotate: 90,
					dashwidth: [0.75, 0.75],
				},
			},
			{
				type: "line",
				json: {
					x: -19.305559794108074,
					y: 49.661113230387365,
					height: 0.4,
					width: 93.33333333333334,
					lineType: 1,
					rotate: 90,
					dashwidth: [0.75, 0.75],
				},
			},
			{
				type: "line",
				json: {
					x: -32.11805979410806,
					y: 49.765279897054036,
					height: 0.4,
					width: 93.54166666666667,
					lineType: 1,
					rotate: 90,
					dashwidth: [0.75, 0.75],
				},
			},
			{
				type: "text",
				json: {
					x: 45.71527353922526,
					y: 19.506946563720703,
					height: 9.875,
					width: 30,
					value: "Machine\n   Type",
					fontFamily: "",
					rotate: 90,
					fontSize: 3.7,
					textAlignHorizonral: 0,
					textAlignVertical: 0,
					letterSpacing: 0,
					lineSpacing: 0,
					lineMode: 6,
					fontStyle: [false, false, false, false],
				},
			},
			{
				type: "text",
				json: {
					x: 32.079856872558594,
					y: 24.26736323038737,
					height: 4.9375,
					width: 30,
					value: "IMEI",
					fontFamily: "",
					rotate: 90,
					fontSize: 3.7,
					textAlignHorizonral: 0,
					textAlignVertical: 0,
					letterSpacing: 0,
					lineSpacing: 0,
					lineMode: 6,
					fontStyle: [false, false, false, false],
				},
			},
			{
				type: "text",
				json: {
					x: 19.256940205891937,
					y: 16.381946563720703,
					height: 9.875,
					width: 30,
					value: "Card Reader\n     S/ N",
					fontFamily: "",
					rotate: 90,
					fontSize: 3.7,
					textAlignHorizonral: 0,
					textAlignVertical: 0,
					letterSpacing: 0,
					lineSpacing: 0,
					lineMode: 6,
					fontStyle: [false, false, false, false],
				},
			},
			{
				type: "text",
				json: {
					x: 7.704856872558594,
					y: 20.51736323038737,
					height: 4.9375,
					width: 30,
					value: "Company",
					fontFamily: "",
					rotate: 90,
					fontSize: 3.7,
					textAlignHorizonral: 0,
					textAlignVertical: 0,
					letterSpacing: 0,
					lineSpacing: 0,
					lineMode: 6,
					fontStyle: [false, false, false, false],
				},
			},
			{
				type: "text",
				json: {
					x: -5.003476460774738,
					y: 23.01736323038737,
					height: 4.9375,
					width: 30,
					value: "Help",
					fontFamily: "",
					rotate: 90,
					fontSize: 3.7,
					textAlignHorizonral: 0,
					textAlignVertical: 0,
					letterSpacing: 0,
					lineSpacing: 0,
					lineMode: 6,
					fontStyle: [false, false, false, false],
				},
			},
			{
				type: "text",
				json: {
					x: -23.84375423855252,
					y: 60.67708545260962,
					height: 4.9375,
					width: 65.875,
					value: help,
					fontFamily: "",
					rotate: 90,
					fontSize: 3.7,
					textAlignHorizonral: 1,
					textAlignVertical: 0,
					letterSpacing: 0,
					lineSpacing: 0,
					lineMode: 6,
					fontStyle: [false, false, false, false],
				},
			},
			{
				type: "text",
				json: {
					x: -12.270837571885835,
					y: 58.465279897054,
					height: 9.875,
					width: 66.25,
					value: company,
					fontFamily: "",
					rotate: 90,
					fontSize: 3.7,
					textAlignHorizonral: 1,
					textAlignVertical: 0,
					letterSpacing: 0,
					lineSpacing: 0,
					lineMode: 6,
					fontStyle: [false, false, false, false],
				},
			},
			{
				type: "barCode",
				json: {
					x: 36.833329094780844,
					y: 56.83333545260958,
					height: 12.625,
					width: 44.625,
					value: machineType,
					codeType: 20,
					rotate: 90,
					fontSize: 2.3,
					textHeight: 2.3,
					textPosition: 0,
				},
			},
			{
				type: "barCode",
				json: {
					x: 24.166662428114137,
					y: 58.23611323038738,
					height: 10.625,
					width: 44.875,
					value: imei,
					codeType: 20,
					rotate: 90,
					fontSize: 2.3,
					textHeight: 2.3,
					textPosition: 0,
				},
			},
			{
				type: "barCode",
				json: {
					x: 10.895829094780822,
					y: 57.40972434149848,
					height: 12.5,
					width: 45.375,
					value: sn,
					codeType: 20,
					rotate: 90,
					fontSize: 2.3,
					textHeight: 2.3,
					textPosition: 0,
				},
			},
		],
		paperColor: ["0.0.0"],
		InitDrawingBoardParam: {
			width: 70,
			height: 100,
			rotate: 0,
			path: "",
			verticalShift: 0,
			HorizontalShift: 0,
		},
	};
}

// 默认导出（使用空值，用于预览）
export const vtmPrintData = createVtmPrintData({
	machineType: "MACHINE001",
	imei: "123456789012345",
	sn: "SN123456789",
	help: "400-123-4567",
	company: "VapeTM Vending\nwww.VapeTM.com",
});
